import React from "react";
import { Rights } from "./Rights";


const SmartFooter = () => {
   
    return (
        <footer>
            <Rights />
        </footer>
    )
}


export default SmartFooter;